export function EquationBlock({ equation, label }: { equation: string; label?: string }) {
  return <div className="eng-equation"><span>{label ?? 'Governing relation'}</span><strong>{equation}</strong></div>
}
